import { AccountEvolution } from './models/account-evolution';
import { DashboardService } from './dashboard.service';
import { TweenMax } from 'gsap';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Auth } from '../../autentication/Auth';
import { Record } from './../extract/models/record';
import { ExtractService } from '../extract/extract.service';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../../shared/EventTypes';
import { AutenticationEventType } from '../../autentication/autentication.event.type';
import { ThemeService } from '../../shared/theme-service/theme.service';
import { Router } from '@angular/router';
import { CustomerServiceService } from '../customer-service/customer-service.service';
import { Account } from '../../autentication/models/account';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { SharedModalInfoComponent } from '../../shared/modal-info/modal-info.component';
import { PixKeysClaimService } from '../pix/keys/keys-claim.service';
import * as moment from 'moment';
import { Util } from '../../utils/util';
import { PixKeyClaim } from '../pix/models/key-claim.model';
import { BankExtract } from '../extract/extract.model';
import { PixKeyClaimTypeEnum } from '../pix/models/key-claim-type';
import { SituacaoReividicacao } from '../pix/models/key.model';
import { RegistrationUpdateModalComponent } from './registration-update-modal/registration-update-modal.component';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit, OnDestroy {

	extractRecords: Array<Record> = [];
	accountEvolutionData: AccountEvolution;
	showBalance = true;
	extractIsLoading = false;
	showInvestments = false;
	userName: string;
	isAttendant = false;
	activeClientAccount: Account;
	showModal = false;

	constructor(
		private dashboardService: DashboardService,
		private extractService: ExtractService,
		private themeService: ThemeService,
		private customerServiceService: CustomerServiceService,
		private router: Router,
		public dialog: MatDialog,
		private pixKeysClaimService: PixKeysClaimService,
	) {

	}

	ngOnInit() {
		AppEventDispatcher.listen(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT, () => {
			this.load();
		});

		TweenMax.delayedCall(.3, () => {
			AppEventDispatcher.dispatch(EventTypes.BALANCE, {show: true, margin: false});
		});

		this.load();

		this.dashboardService.emitterInvestments.subscribe(value => this.showInvestments = value);

		this.checkPixRules();

		this.getRegisteredDevice();
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT);
	}

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.messages[0] });

	get isMobile() {
		return Util.isMobile();
	}

	openRegistrationUpdateModal() {
		const width = this.isMobile ? '100%' : '600px';
		const dialogConfig: MatDialogConfig = {
			width: width,
			maxWidth: width,
			height: this.isMobile ? '100%' : '517px',
			panelClass: 'round-dialog',
		};
		this.dialog.open(
			RegistrationUpdateModalComponent,
			dialogConfig
		);
	}

	getRegisteredDevice() {
		if (localStorage.getItem('isRegistrationModalViewed') === 'true') return;

		this.dashboardService.getShowBanner().subscribe(data => {
			if (data.showBanner) {
				localStorage.setItem('isRegistrationModalViewed', 'true');
				this.openRegistrationUpdateModal();
			}
		}, error => {
			this.handleError(error);
		});
	}

	getList() {
		this.extractIsLoading = true;
		const dateBegin = Util.DateAddDay(-7);

		this.extractService.getNewExtract(moment(dateBegin).format('YYYY-MM-DD'), null, true).subscribe(result => {
			if (result.Sucesso && result.Existe) {
				this.extractRecords = [];
				const items = Util.keysToCamel(result.Retorno) as BankExtract;
				this.extractRecords = this.extractService.convertModelToView(items);
			}
		});
	}

	load() {
		this.userName = Auth.getInstance().getUser().loggedUserName.split(' ')[0];
		this.getList();
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {element: '[data-component="dashboard"] .content', show: active, delay: delay});
	}
	loadedPixClaimKeyData = () => sessionStorage.getItem("loadedPixClaimKeyData") === 'true';

	checkPixRules() {
	  if(this.loadedPixClaimKeyData()){
		return;
	  }

	  this.getListClaimsReceive();
	  this.getListClaimsRequest();
	  sessionStorage.setItem("loadedPixClaimKeyData", "true");
	}

	getListClaimsReceive() {
		const beginDate = moment(new Date()).subtract(14, 'days').format('YYYY-MM-DD');

		this.pixKeysClaimService.getReceive(beginDate, '').subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				const items = Util.keysToCamel(result.Retorno) as PixKeyClaim[];
				if (!this.showModal) {
					this.openModalClaim();
					this.showModal = true;
				}
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	getListClaimsRequest() {
		const beginDate = moment(new Date()).subtract(14, 'days').format('YYYY-MM-DD');

		this.pixKeysClaimService.getRequest(beginDate, '').subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				const items = Util.keysToCamel(result.Retorno) as PixKeyClaim[];
				const confirmKey = items.find(e => e.situacao === SituacaoReividicacao.CONFIRMADA);

				if (!!confirmKey && confirmKey.tipo === PixKeyClaimTypeEnum.REIVINDICACAO && !this.showModal) {
					this.openModalClaim();
					this.showModal = true;
				}
			}
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	openModalClaim() {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '360px',
			data: {
				title: 'Você tem um pedido ou confirmação de chave Pix',
				text: 'Você pode aprovar ou reprovar um pedido ou confirmar uma solicitação acessando a tela de Minhas Chaves.',
				btnName: 'Ir para minhas chaves',
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.router.navigate(['pix/chaves/listar']);
			}
		});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/dashboard.component.ts